export enum ReferralScheduleStatusTypesEnum {
    Approved = 1,
    AttendanceVerified = 2,
    AttendanceRejected = 3,
    ClaimantNotAttended = 4,
    Completed = 5,
    VendorCancelled = 6,
    AdjusterCancelled = 7
}